var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCaseDifficultyVeryHard = function SvgCaseDifficultyVeryHard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11.25,
    width: 3,
    height: 3.75,
    fill: "#282625"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7.5,
    width: 3,
    height: 7.5,
    fill: "#282625"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.75,
    width: 3,
    height: 11.25,
    fill: "#282625"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 3,
    height: 15,
    fill: "#282625"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCaseDifficultyVeryHard);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMTEuMjUiIHdpZHRoPSIzIiBoZWlnaHQ9IjMuNzUiIGZpbGw9IiMyODI2MjUiLz4KPHJlY3QgeD0iNCIgeT0iNy41IiB3aWR0aD0iMyIgaGVpZ2h0PSI3LjUiIGZpbGw9IiMyODI2MjUiLz4KPHJlY3QgeD0iOCIgeT0iMy43NSIgd2lkdGg9IjMiIGhlaWdodD0iMTEuMjUiIGZpbGw9IiMyODI2MjUiLz4KPHJlY3QgeD0iMTIiIHdpZHRoPSIzIiBoZWlnaHQ9IjE1IiBmaWxsPSIjMjgyNjI1Ii8+Cjwvc3ZnPgo=";